import axiosClient from "../axiosClient";

export const getThoughtLeaders = async () => {
    return await axiosClient.get('/thought_leader_all');
};

export const getThoughtLeaderById = async (id) => {
    return await axiosClient.get(`/thought_leader_by_id/${id}`);
};

export const changeThoughtLeaderStatus = async (data) => {
    return await axiosClient.put(`/edit_thought_leader_status`, data);
};

export const sendMailThoughtLeader = async (data) => {
    return await axiosClient.post('/send_mail_thought_leader', data);
};

export const addThoughtLeader = async (data) => {
    return await axiosClient.post('/add_thought_leader', data);
};

export const editThoughtLeader = async (data) => {
    return await axiosClient.put('/edit_thought_leader', data);
};

export const deleteThoughtLeader = async (id) => {
    return await axiosClient.delete(`/delete_thought_leader/${id}`);
};

export const getRecThoughtLeaders = async () => {
    return await axiosClient.get('/get_recommended_tl');
};

export const addRecommendedLeader = async (data) => {
    return await axiosClient.post('/add_recommended_tl', data);
};